import { setupFormState } from '@/components/form/tidal-form'

import { TrackingPageFormValues } from './typings'

export const form = setupFormState<TrackingPageFormValues>({
  id: 'trackingPageForm',
  initialValues: {
    id: '',
    companyName: '',
    companySlogan: '',
    companyPhone: '',
    companyEmail: '',
    showContactPhone: false,
    showContactEmail: false,
    useCompanyEmailAsReplyTo: false,
    showEtaRange: false,
    showPicturePod: false,
    showSignaturePod: false,
    showAudioPod: false,
    showNotePod: false,
  },
})
